"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _index = require("../index");

var _index2 = _interopRequireDefault(_index);

var _accounts = require("../../accounts");

var _accounts2 = _interopRequireDefault(_accounts);

var _registrations = require("../../registrations");

var _registrations2 = _interopRequireDefault(_registrations);

var _payments = require("../../payments");

var _payments2 = _interopRequireDefault(_payments);

var _common = require("../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = angular.module('ifeis.printing.compcards', ['ifeis.payments']).factory('fPrintCompCards', function ($q, fFeisService, fPaymentsService, fRegistrationService, fAccountService, fPrint) {
  var _this = this;

  var orderRegistrations = function orderRegistrations(regs) {
    var eventsNameSorting = ['Reel', 'Light Jig', 'Slip Jig', 'Single Jig', 'Treble Jig', 'Hornpipe'];

    var grades = regs.filter(function (r) {
      return eventsNameSorting.indexOf(r.event.event) > -1;
    }).sort(function (a, b) {
      return eventsNameSorting.indexOf(a.event.event) - eventsNameSorting.indexOf(b.event.event);
    });
    var figures = regs.filter(function (r) {
      return r.event.type === 'F';
    });
    var specials = regs.filter(function (r) {
      return r.event.type === 'S';
    });
    var others = regs.filter(function (r) {
      return eventsNameSorting.indexOf(r.event.event) < 0 && r.event.type !== 'F' && r.event.type !== 'S';
    });

    return [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(grades ? grades : []), _toConsumableArray(figures ? figures : []), _toConsumableArray(specials ? specials : []), _toConsumableArray(others ? others : [])))));
  };

  var print = function print(pages, feisName) {

    function drawFront(person, quad, params, doc) {
      var numberSize = 220;
      var numberHeightOffset = (params.qHeight - numberSize) / 2;

      doc.fontSize(numberSize).font('Helvetica-Bold');

      doc.text(person.competitor, quad.x - 30, quad.y + numberHeightOffset, {
        width: params.qWidth + 50,
        height: params.qHeight,
        align: 'center'
      });

      var eventsString = person.registrations.map(function (r) {
        return r.event.name;
      }).join(', ');

      doc.fontSize(params.textSize).font('Helvetica');
      doc.text(eventsString, quad.x, quad.y + params.pageHeight / 2 - params.margin * 2.5 + params.textSize, {
        width: params.qWidth,
        align: 'center',
        height: params.textSize * 3,
        lineBreak: true
      });
    }

    (0, _common.createCompetitorInfoCards)(fPrint, drawFront.bind(_this), pages, feisName, 'competitor-cards.pdf');
  };

  // Competitor is an optional parameter used when generating a report with a single competitor
  var printCards = function printCards(fid, competitor) {
    var regSvc = fRegistrationService.for(fid);
    // if no competitor provided then fetch all competitors and their registrations
    if (competitor === undefined) {
      return regSvc.all().then(function (reg) {
        // sort by last name, first name without case sensitivity
        reg.sort(function (a, b) {
          return a.lname.localeCompare(b.lname, 'en', { 'sensitivity': 'base' }) || a.fname.localeCompare(b.fname, 'en', { 'sensitivity': 'base' });
        });
        // Order registrations
        var orderedReg = reg.map(function (c) {
          return _extends({}, c, {
            registrations: orderRegistrations(c.registrations)
          });
        });
        // Combine this into an array of arrays, with 4 competitors per subarray (to match pagination).
        var tmpArray = [];
        return orderedReg.reduce(function (coll, c, idx, arr) {
          tmpArray.push(c);
          if (tmpArray.length >= 4 || arr.length - 1 === idx) {
            coll.push(tmpArray);
            tmpArray = [];
          }
          return coll;
        }, []);
      }).then(function (pages) {
        // add 10 blank competitor cards for late additions
        var highestCompNum = 0;
        pages.forEach(function (page) {
          page.forEach(function (competitor) {
            if (competitor.competitor > highestCompNum) {
              highestCompNum = competitor.competitor;
            }
          });
        });
        var blankComp = {
          "fname": "               ",
          "lname": "",
          "id": "",
          "gender": "",
          "dob": "",
          "champion": 0,
          "school": {
            "name": ""
          },
          "account_id": "",
          "public_reg": null,
          "registrations": []
        };
        var newCompetitors = [];
        for (var _i = 0; _i < 10; _i++) {
          var newCompetitor = Object.assign({}, blankComp);
          newCompetitor.competitor = highestCompNum + 1 + _i;
          newCompetitors.push(newCompetitor);
        }
        var i = 0;
        while (i < newCompetitors.length) {
          if (pages[pages.length - 1].length < 4) {
            pages[pages.length - 1].push(newCompetitors[i]);
            i++;
          } else {
            pages.push([newCompetitors[i], newCompetitors[i + 1], newCompetitors[i + 2], newCompetitors[i + 3]]);
            i += 4;
          }
        }
        pages = pages.map(function (page) {
          return page.filter(function (competitor) {
            return competitor !== undefined;
          });
        });

        fFeisService.one(fid).then(function (feis) {
          return print(pages, feis.name);
        });
      });
      // if competitor is provided then fetch their registrations
    } else {
      return regSvc.for(competitor.id).all().then(function (reg) {
        competitor.registrations = orderRegistrations(reg);
        return [[competitor]];
      }).then(function (pages) {
        fFeisService.one(fid).then(function (feis) {
          return print(pages, feis.name);
        });
      });
    }
  };

  return printCards;
});


//////////////////
// WEBPACK FOOTER
// ./print/comp-cards/index.js
// module id = 490
// module chunks = 0